const local = '_PROVIDER_TIPO_DE_MISSAO_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_TIPO_DE_MISSAO: function (callback) {
			this._httpGet('/Tipo_missao/get', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerTipoDeMissaoUpdate: function () {
			//console.log("update orgao apoiado")
			// ESTADOS
			this._GET_TIPO_DE_MISSAO(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerTipoDeMissao: function (callback) {
			//console.log("update orgao apoiado", update)

			if (!update) {
				update = true
				this._GET_TIPO_DE_MISSAO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_TIPO_DE_MISSAO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}